module.exports = __webpack_public_path__ + "img/AM.5bdf91f2.svg";